import {TypedUseSelectorHook, useSelector as useReduxSelector} from "react-redux";
import {RootState} from "../reducers";

const useTypedSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export default useTypedSelector;